import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import GrantAccessDialogLoaderQuery, {
	type GrantAccessDialogLoaderQuery$data,
	type GrantAccessDialogLoaderQuery$variables,
} from './__generated__/GrantAccessDialogLoaderQuery.graphql.ts';
import type { GraphQLError } from 'graphql';

export function preloadGrantAccessDialogData(
	contentId: string,
	accountId: string,
): Promise<{
	data: GrantAccessDialogLoaderQuery$data | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> {
	return query<GrantAccessDialogLoaderQuery$data, GrantAccessDialogLoaderQuery$variables>({
		query: GrantAccessDialogLoaderQuery,
		variables: { contentId, accountId },
	});
}
